import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FiArrowUpRight,
    FiFileText,
    FiBarChart,
    FiActivity,
    FiCalendar,
} from 'react-icons/fi';
import { PageHeader } from '../../theme/components';
import './Report.css';

const Report = () => {
    const navigate = useNavigate();

    const reportCards = [
        {
            id: 1,
            title: 'Child Registration Report',
            description: 'Master list of all registered children.',
            icon: FiFileText,
            accent: 'primary',
            link: '/reports/child-registration',
        },
        {
            id: 2,
            title: 'Upcoming Vaccinations Report',
            description: 'Per-vaccine dose counts for upcoming vaccinations (next 14 days).',
            icon: FiCalendar,
            accent: 'info',
            link: '/reports/upcoming-vaccinations',
        },
        {
            id: 3,
            title: 'Vaccination Status Report',
            description: 'Overview of completed, upcoming, and overdue vaccinations.',
            icon: FiBarChart,
            accent: 'success',
            link: '/reports/vaccine-summaries',
        },
        {
            id: 4,
            title: 'Growth Monitoring Report',
            description: "Overview of children's growth parameters and required follow-ups.",
            icon: FiActivity,
            accent: 'warning',
            link: '/reports/growth-monitoring',
        },
    ];

    return (
        <div className="reports-wrapper">
            <PageHeader
                title="System Reports"
                subtitle="View summaries and insights of child health records."
                icon={FiFileText}
            />
            <div className="reports-body">
                <div className="reports-grid">
                    {reportCards.map((card) => {
                        const Icon = card.icon;
                        return (
                            <button
                                key={card.id}
                                type="button"
                                className={`report-card report-card--${card.accent}`}
                                onClick={() => navigate(card.link)}
                            >
                                <span className="report-card__icon" aria-hidden="true">
                                    <Icon size={22} />
                                </span>
                                <span className="report-card__content">
                                    <span className="report-card__title">{card.title}</span>
                                    <span className="report-card__desc">{card.description}</span>
                                </span>
                                <span className="report-card__arrow" aria-hidden="true">
                                    <FiArrowUpRight size={20} />
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Report;
